import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color", "format", "hasColor", "id", "isCompact", "isUnstyled", "locale", "maximumFractionDigits", "minimumFractionDigits", "mode", "signDisplay", "size", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { StyledFormatNumber } from './FormatNumber.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var FormatNumber = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      controlledColor = _ref.color,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'decimal' : _ref$format,
      _ref$hasColor = _ref.hasColor,
      hasColor = _ref$hasColor === void 0 ? false : _ref$hasColor,
      id = _ref.id,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      _ref$isUnstyled = _ref.isUnstyled,
      isUnstyled = _ref$isUnstyled === void 0 ? false : _ref$isUnstyled,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
      _ref$maximumFractionD = _ref.maximumFractionDigits,
      maximumFractionDigits = _ref$maximumFractionD === void 0 ? 2 : _ref$maximumFractionD,
      _ref$minimumFractionD = _ref.minimumFractionDigits,
      minimumFractionDigits = _ref$minimumFractionD === void 0 ? 0 : _ref$minimumFractionD,
      mode = _ref.mode,
      _ref$signDisplay = _ref.signDisplay,
      signDisplay = _ref$signDisplay === void 0 ? 'auto' : _ref$signDisplay,
      size = _ref.size,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var formatConfig = {
    style: format,
    notation: isCompact ? 'compact' : 'standard',
    signDisplay: signDisplay,
    compactDisplay: 'short',
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits
  };
  var numberFormatter = new Intl.NumberFormat(locale, formatConfig);
  var formatNumber = numberFormatter.format(value);
  var numberSign = Math.sign(value);

  var numberSignSwitch = function numberSignSwitch(sign) {
    return {
      1: 'positive',
      0: 'zero',
      '-1': 'negative'
    }[sign];
  };

  var controlledColorSwitch = function controlledColorSwitch(status) {
    return {
      positive: 'positive',
      neutral: 'neutral',
      negative: 'negative'
    }[status] || 'neutral';
  };

  var color = controlledColor && controlledColorSwitch(controlledColor) || hasColor && numberSignSwitch(numberSign);
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-format-number"), true), _defineProperty(_cx, "".concat(prefix, "-format-number__").concat(color), controlledColor || hasColor), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return isUnstyled ? formatNumber : _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(StyledFormatNumber, _objectSpread(_objectSpread({
      ref: ref,
      className: className
    }, rest), {}, {
      children: formatNumber
    }))
  });
});
FormatNumber.displayName = 'FormatNumber';
export default FormatNumber;